import { createStore } from 'vuex';
import aiGuess from './modules/aiGuess';


export default createStore({
    modules: {
        aiGuess,
    }
})